import { RootState } from '../index';
import { Participant, SampleKit, SampleLink, StoreStatus } from '../../core/types/common.types';

export const errorSelector = (state: RootState): any | null => state.participant.errors || null;
export const hasErrorSelector = (state: RootState): boolean => (state.participant.errors ? true : false);

export const isBusySelector = (state: RootState): boolean => state.participant.status === StoreStatus.BUSY;

export const responseSelector = (state: RootState): Participant | null => state.participant.response || null;

export const hasSuccessSelector = (state: RootState): boolean => (state.participant.response ? true : false);

export const sampleKitSelector = (state: RootState): SampleKit | null => state.participant.sampleKit || null;

export const sampleLinkSelector = (state: RootState): SampleLink | null => state.participant.sampleLink || null;
